// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Runtime environment config injected by the container entrypoint (env.js).
// Falls back to the staging Firebase project when no runtime config is provided.
const env = (typeof window !== "undefined" && window.__ENV__) || {};

// Your web app's Firebase configuration
// This should match the configuration in the mobile app
const firebaseConfig = {
  apiKey: env.FIREBASE_API_KEY || "AIzaSyCCD9PIhJ-JYd3wHQuTS4yrJwPxi0cAF18",
  authDomain: env.FIREBASE_AUTH_DOMAIN || "anipaw-4960e.firebaseapp.com",
  projectId: env.FIREBASE_PROJECT_ID || "anipaw-4960e",
  storageBucket: env.FIREBASE_STORAGE_BUCKET || "anipaw-4960e.firebasestorage.app",
  messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID || "1030642495811",
  appId: env.FIREBASE_APP_ID || "1:1030642495811:web:858da30a6739a9b8c1fff6",
  measurementId: env.FIREBASE_MEASUREMENT_ID || "G-CFZ1XFLGNB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export { app, auth };
